import { Component, computed, Signal, signal, ViewChild, WritableSignal } from '@angular/core';
import { ModalComponent } from '../../modal/modal.component';
import { TranslateModule } from '@ngx-translate/core';
import { RibbonStyles } from 'src/app/models/constants/store-services.constant';
import { RibbonColor } from 'src/app/models/enums/Ribbon.enum';
import { Ribbon } from 'src/app/models/types/Ribbon.type';
import { RibbonColorPreviewComponent } from './ribbon-color-preview/ribbon-color-preview.component';
import { RibbonBentoViewComponent } from './ribbon-bento-view/ribbon-bento-view.component';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/modules/shared.module';

@Component({
  selector: 'app-ribbon-modal',
  imports: [
    ModalComponent,
    // RibbonColorPreviewComponent,
    RibbonBentoViewComponent,
    SharedModule
  ],
  templateUrl: './ribbon-modal.component.html',
  styleUrl: './ribbon-modal.component.scss'
})
export class RibbonModalComponent {

  private _selected: WritableSignal<RibbonColor | null> = signal(RibbonColor.ORANGE);
  // private _selected: WritableSignal<RibbonColor | null> = signal(null);
  public selected: Signal<RibbonColor | null> = computed(() => this._selected());

  // public ribbonsList: WritableSignal<Ribbon[]> = signal([]);

  public selectedRibbon: Signal<Ribbon | null> = computed(() => {
    if (this._selected() === null) {
      return null;
    }
    return RibbonStyles.get(this._selected()!)!;
  });

  public showBentoView: Signal<boolean> = computed(() => this._selected() !== null);

  @ViewChild('modal', { static: false }) modal!: ModalComponent;

  openModal() {
    // this.ribbonsList.set(Array.from(RibbonStyles.values()));
    // this._selected.set(null);
    this._selected.set(RibbonColor.ORANGE);
    this.modal.buildModal(() => this.handleClose(), 'modal-fullscreen');
  }

  handleConfirm() {
    this.handleClose()
  }

  private handleClose() {
    this.modal.dismiss();
  }

  handleRibbonColorPreviewClick(ribbonColor: RibbonColor) {
    this._selected.set(ribbonColor);
  }

}
